var map = {
	"./bn-IN.yml": [
		2366,
		2366
	],
	"./de-DE.yml": [
		69494,
		9494
	],
	"./en-ZA.yml": [
		38589,
		8589
	],
	"./en.yml": [
		44640
	],
	"./es-ES.yml": [
		38223,
		8223
	],
	"./fr-FR.yml": [
		27497,
		7497
	],
	"./hi-IN.yml": [
		54882,
		4882
	],
	"./id-ID.yml": [
		40835,
		835
	],
	"./it.yml": [
		87201,
		7201
	],
	"./ph-PH.yml": [
		47129,
		7129
	],
	"./pt-BR.yml": [
		72775,
		2775
	],
	"./tr-TR.yml": [
		87631,
		7631
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 35951;
module.exports = webpackAsyncContext;